"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CyclicBlueprintRefError = void 0;
var CyclicBlueprintRefError = /** @class */ (function (_super) {
    __extends(CyclicBlueprintRefError, _super);
    function CyclicBlueprintRefError(_a) {
        var blueprintRefDataObjectId = _a.blueprintRefDataObjectId;
        var _this = _super.call(this, "Unable to do action on dataobject ".concat(blueprintRefDataObjectId, " a blueprint ref cycle is created")) || this;
        Object.setPrototypeOf(_this, CyclicBlueprintRefError.prototype);
        return _this;
    }
    return CyclicBlueprintRefError;
}(Error));
exports.CyclicBlueprintRefError = CyclicBlueprintRefError;
